var map = {
	"./ambient-bg.svg": 6692,
	"./categories/CPU.svg": 4846,
	"./categories/Case.svg": 1695,
	"./categories/Cooler.svg": 4952,
	"./categories/DVD Drive.svg": 2240,
	"./categories/Display.svg": 393,
	"./categories/Flash Drive.svg": 6758,
	"./categories/GPU.svg": 460,
	"./categories/HDD.svg": 9863,
	"./categories/Keyboard.svg": 6764,
	"./categories/Motherboard.svg": 2894,
	"./categories/Mouse.svg": 3120,
	"./categories/Multimedia.svg": 3724,
	"./categories/Power Block.svg": 6646,
	"./categories/Printer.svg": 5045,
	"./categories/RAM.svg": 256,
	"./category-default.svg": 8314,
	"./demo/0.jpg": 1502,
	"./demo/1.jpg": 5925,
	"./demo/1.png": 2462,
	"./demo/10.png": 7850,
	"./demo/11.png": 4427,
	"./demo/12.png": 2863,
	"./demo/123.jpg": 5738,
	"./demo/2.jpg": 4703,
	"./demo/2.png": 9390,
	"./demo/3.jpg": 6191,
	"./demo/3.png": 8975,
	"./demo/4.png": 6331,
	"./demo/5.png": 8276,
	"./demo/6.png": 880,
	"./demo/7.png": 9194,
	"./demo/8.png": 2202,
	"./demo/9.png": 9648,
	"./demo/img.png": 4101,
	"./icons/all-categories.svg": 8696,
	"./icons/back.svg": 7911,
	"./icons/chevron.svg": 5964,
	"./icons/close.svg": 420,
	"./icons/favorite-filled.svg": 1949,
	"./icons/favorite.svg": 8416,
	"./icons/menu-hide.svg": 6767,
	"./icons/menu-show.svg": 8627,
	"./icons/moon.svg": 8806,
	"./icons/phone.svg": 9193,
	"./icons/search.svg": 9262,
	"./icons/share.svg": 3906,
	"./icons/slider-arrow.png": 6057,
	"./icons/sun.svg": 5518,
	"./lang/en.png": 3663,
	"./lang/ru.png": 2661,
	"./lang/uz.png": 926,
	"./logo-lt.svg": 7442,
	"./logo-lt_.svg": 4184,
	"./logo-lt__.svg": 9659,
	"./logo-text.svg": 1879,
	"./logo.svg": 9574,
	"./menu-active.svg": 1830,
	"./social/ig.svg": 6097
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7173;